import { useState } from 'react';

export interface CriteriaOptionValue {
  first_value: string;
  second_value: string;
  operator?: string;
  error?: string[];
  criteria_type_id?: number;
  wholeNumber?: boolean;
}

export const useRangeCriteria = ({
                                   first_value,
                                   second_value,
                                   wholeNumber = false,
                                 }: CriteriaOptionValue) => {
  const [formData, setData] = useState<CriteriaOptionValue>({
    first_value,
    second_value,
    operator: '',
  });

  const validateNotInt = (input: CriteriaOptionValue) => {
    const numberOne = Number(input.first_value);
    const numberTwo = Number(input.second_value);
    if (!Number.isInteger(numberOne) || !Number.isInteger(numberTwo)) {
      return 'Solo se permiten números enteros en Código postal rango';
    } else {
      return '';
    }
  };

  const validateGreaterThan = (input: CriteriaOptionValue) => {
    const numberOne = Number(input.first_value);
    const numberTwo = Number(input.second_value);
    if (numberOne !== 0 && numberTwo !== 0) {
      if (numberOne > numberTwo) {
        return 'El primer valor no puede ser mayor al segundo valor';
      } else {
        return '';
      }
    } else {
      return '';
    }
  };

  const handleOnChange = (input: CriteriaOptionValue) => {
    if (Number(input.first_value) >= 0 && Number(input.second_value) >= 0) {
      let operator = 'between';
      if (input.first_value !== '' && input.second_value === '')
        operator = '>=';
      if (input.first_value === '' && input.second_value !== '')
        operator = '<=';
      if (input.first_value === '' && input.second_value === '') operator = '';
      const result = [];
      if (wholeNumber) {
        result.push(validateNotInt(input));
      }
      result.push(validateGreaterThan(input));
      setData({ ...formData, ...input, operator, error: result });
      return { ...formData, ...input, operator, error: result };
    }
    return { ...formData, ...input };
  };

  const getStep = () => {
    return wholeNumber !== undefined ? '1' : '0.10';
  };

  return {
    formData,
    handleOnChange,
    getStep,
  };
};
